module.exports = __webpack_public_path__ + "static/media/white-check.a4c21e05.svg";